module.exports = __webpack_public_path__ + "static/media/biometric.6564645c.svg";